import { FavoriteReference, FavoriteType, ID } from '@griply/types';

export const toggleFavoriteList = (
  favorites: FavoriteReference[],
  id: ID,
  type: FavoriteType,
): FavoriteReference[] => {
  const withoutTarget = favorites.filter(
    (favorite) => !(favorite.id === id && favorite.type === type),
  );

  if (withoutTarget.length !== favorites.length) {
    return withoutTarget;
  }

  return [...favorites, { id, type }];
};
